import { useScreenBreakpoint } from 'consts/breakpoints';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GAloadTimestampSelector } from 'store/state/app/selectors';

interface GoogleButtonProps {
  parent: React.MutableRefObject<HTMLDivElement>;
  containerRef: React.MutableRefObject<HTMLDivElement>;
  theme?: GsiButtonConfiguration['theme'];
}

export const useLoginWithGoogleButton = ({ parent, theme = 'outline', containerRef }: GoogleButtonProps): void => {
  const [ apiLoaded, setApiLoaded ] = useState(false);
  const GATimestamp = useSelector(GAloadTimestampSelector);
  const isDesktop = useScreenBreakpoint() >= 3;

  useEffect(() => {
    if (window.google && !apiLoaded) {
      setApiLoaded(true);
    }
  }, [ GATimestamp ]);

  useEffect(() => {
    if (apiLoaded && parent.current && theme && containerRef.current) {
      const wrapper = document.createElement('div');
      const width = containerRef.current.clientWidth;
      wrapper.style.cssText = 'height:40px;overflow:hidden;';

      window.google.accounts.id.renderButton(
        wrapper,
        {
          theme,
          type: 'standard',
          size: 'large',
          shape: 'circle',
          text: 'continue_with',
          locale: 'he_IL',
          width: `${isDesktop ? (width || 385) : (width || 320)}px`,
        }
      );
      parent.current.appendChild(wrapper);
    }
  }, [ parent.current, theme, apiLoaded, containerRef.current ]);

  return null;
};
